import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import { colors, fontSize, fontWeight, TypographyStyledGlobal } from '../../../../theme';
import useFetcher from '../../../../utils/hooks/useFetcher';
import Loader from '../../../Loader/loader';
import { InputStyled, StyledFormControl } from '../../AddDashboardModal/styled';
import { SelectedSurveyProps } from '../addSurveyInterface';
import { FormControlStyled, LoaderContentStyled } from '../styled';
import SurveyModal from '../surveyModal';

interface StepSelectSurveyInterface {
    selectedSurvey?: SelectedSurveyProps
    handleSelectedSurvey: (survey: SelectedSurveyProps) => void
}

const StepSelectSurvey: FC<StepSelectSurveyInterface> = ({ selectedSurvey, handleSelectedSurvey }) => {
    const { t } = useTranslation('settings');
    const fetcher = useFetcher();
    const { data: fetchedSurveysFromAskia } = useSWR(`${process.env.REACT_APP_API_URL}/askia/surveys`, fetcher);
    const [filteredSurveys, setFilteredSurveys] = useState<SelectedSurveyProps[] | undefined>(undefined);
    const [searchValue, setSearchValue] = useState<string>('');

    const handleChangeSurvey = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
    };
    useEffect(() => {
        if (!fetchedSurveysFromAskia) {
            return;
        }
        let filteredSurveysToSet: SelectedSurveyProps[] = fetchedSurveysFromAskia.map((survey: SelectedSurveyProps) => survey);
        if (searchValue !== '') {
            filteredSurveysToSet = filteredSurveysToSet.filter((survey) => survey.description.toLowerCase().includes(searchValue.toLowerCase()));
        }
        filteredSurveysToSet.sort((a, b) => a.name.localeCompare(b.name));
        setFilteredSurveys(filteredSurveysToSet);
    }, [fetchedSurveysFromAskia, searchValue]);

    return (
        <StyledFormControl>
            <InputStyled
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeSurvey(e)}
                placeholder={t('surveys.modal.placeholder')}
                value={searchValue}
            />
            {!filteredSurveys && (
                <LoaderContentStyled>
                    <Loader size={14} />
                    <TypographyStyledGlobal
                        color={colors.grey200}
                        size={fontSize.sm}
                        weight={fontWeight.light}
                    >
                        {t('surveys.modal.loadingSurveys')}
                    </TypographyStyledGlobal>
                </LoaderContentStyled>
            )}
            <FormControlStyled>
                {filteredSurveys?.map((survey: SelectedSurveyProps) => (
                    <SurveyModal
                        key={survey.id}
                        handleSelectedSurvey={handleSelectedSurvey}
                        selectedSurveyId={selectedSurvey && selectedSurvey.id}
                        survey={survey}
                    />
                ))}
            </FormControlStyled>
        </StyledFormControl>
    );
};

export default StepSelectSurvey;
